var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get } from "lodash";
import { BasketItemType } from "@irati/types";
import id from "@irati/utils/id";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import getDealCurrency from "@irati/deals/helpers/deals/currency";
import { Body } from "@irati/ui/src/Typography";
import { OverlayPlacement } from "@irati/ui/src/Tooltip/Overlay";
import basket from "@irati/checkout/utils/basket";
import OpenValueInput from "../Quantity/OpenValueInput";
import StyledTooltip from "../styled/Tooltip";
var OpenValueInputContainer = /** @class */ (function (_super) {
    __extends(OpenValueInputContainer, _super);
    function OpenValueInputContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOpenValueChange = function (productId, value) {
            if (value) {
                var openValue = parseInt(value, 10) * 100;
                basket.setProduct(BasketItemType.Deal, _this.props.deal.uuid, productId, { openValue: openValue, count: 1 });
            }
            else {
                basket.clear();
            }
        };
        return _this;
    }
    OpenValueInputContainer.prototype.render = function () {
        var _this = this;
        var _a = this.props, deal = _a.deal, products = _a.products;
        var minValue = get(deal, "productConfig.limits.forOpenValue.minValue");
        var maxValue = get(deal, "productConfig.limits.forOpenValue.maxValue");
        return (React.createElement("div", null,
            React.createElement(Body, { weight: "bold", marginBottom: 1 },
                React.createElement(FormattedMessage, { id: "perks.productForms.openValueProduct.voucherAmount.para" })),
            React.createElement(Body, null,
                React.createElement(FormattedMessage, { id: "perks.productForms.openValueProduct.minMax.label", values: {
                        minValue: formatCurrency({
                            currencyCode: getDealCurrency(deal),
                            isCents: false,
                            value: minValue,
                            trimZerosFromWholeNumber: true
                        }),
                        maxValue: formatCurrency({
                            currencyCode: getDealCurrency(deal),
                            isCents: false,
                            value: maxValue,
                            trimZerosFromWholeNumber: true
                        })
                    } }),
                React.createElement(StyledTooltip, { icon: "i", placement: OverlayPlacement.Top },
                    React.createElement(Body, { small: true, weight: "semibold" },
                        React.createElement(FormattedMessage, { id: "perks.productForms.openValueProduct.tooltip.title" })),
                    React.createElement(Body, { small: true, padding: [1, 0] },
                        React.createElement(FormattedMessage, { id: "perks.productForms.openValueProduct.tooltip.description" })))),
            products.map(function (item) { return (React.createElement(OpenValueInput, { key: item.uuid, minValue: minValue, maxValue: maxValue, product: item, handleChange: _this.handleOpenValueChange, id: id(item.name, _this.props) })); })));
    };
    return OpenValueInputContainer;
}(PureComponent));
export default injectIntl(OpenValueInputContainer);
